export interface StationSearch {
  id: number;
  name: string;
  source_id?: number | null;
  elevation?: number | null;
  overwriteStationName?: string;
  nameOfSource?: string;
}

export function normalizeStationSearch(raw: any): StationSearch | null {
  const id = Number(raw?.id ?? raw?.stationId);
  const name =
    typeof raw?.name === 'string'
      ? raw.name.trim()
      : typeof raw?.overwriteStationName === 'string'
        ? raw.overwriteStationName.trim()
        : '';

  if (!Number.isFinite(id) || !name) {
    return null;
  }

  const sourceIdRaw = raw?.source_id ?? raw?.sourceId;
  const elevationRaw = raw?.elevation;

  return {
    id,
    name,
    source_id:
      sourceIdRaw === undefined || sourceIdRaw === null
        ? null
        : Number(sourceIdRaw),
    elevation:
      elevationRaw === undefined || elevationRaw === null || elevationRaw === ''
        ? null
        : Number(elevationRaw),
    overwriteStationName:
      typeof raw?.overwriteStationName === 'string' &&
      raw.overwriteStationName.trim()
        ? raw.overwriteStationName.trim()
        : name,
  };
}
